import { Component, EventEmitter, Output } from '@angular/core';
import { CerrixSearchInputComponent } from '@app/shared/atoms/cerrix-search-input/cerrix-search-input.component';
import { CerrixButtonComponent } from '@app/shared/atoms/cerrix-button/cerrix-button.component';

@Component({
  selector: 'cerrix-add-and-filter-bar',
  templateUrl: './cerrix-add-and-filter-bar.component.html',
  styleUrls: ['./cerrix-add-and-filter-bar.component.scss'],
  imports: [
      CerrixSearchInputComponent,
      CerrixButtonComponent
  ],
})
export class CerrixAddAndFilterBarComponent {
  @Output() addButtonClicked: EventEmitter<void> = new EventEmitter();
  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();

}
